export const registeredUsersData = {
    title: "Registered Users",
    total: "93 350",
    percent: 14.32,
    period: "since last month"
};

export const activeMissionsData = {
    title: "Active Missions",
    total: "450",
    percent: 8.01,
    period: "since last month"
}

export const dailyVisitorsData = {
    title: "Avg Daily Visitors",
    total: "1 777",
    percent: 7.99,
    period: "since last month"
}

export const donatData = [
    {
        type: 'Clients',
        value: 37,
    },
    {
        type: 'Delegates',
        value: 49,
    },
    {
        type: 'Pending',
        value: 14,
    },
];

export const donatSummaryData = ["40 162", "53 188", "15 196"];

export const lineData = [
    {
        year: '1991',
        value: 1,
    },
    {
        year: '1992',
        value: 1.5,
    },
    {
        year: '1993',
        value: 2,
    },
    {
        year: '1994',
        value: 2.5,
    },
    {
        year: '1995',
        value: 2.9,
    },
    {
        year: '1996',
        value: 3,
    },
    {
        year: '1997',
        value: 3.6,
    },
    {
        year: '1998',
        value: 4,
    },
    {
        year: '1999',
        value: 4.4,
    },
];